module.exports = __webpack_public_path__ + "static/media/ico-search.f310c1cb.svg";